import { render, staticRenderFns } from "./TruckingCategory.vue?vue&type=template&id=264e7ea6&"
import script from "./TruckingCategory.vue?vue&type=script&lang=js&"
export * from "./TruckingCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports